function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.618 1.357A1.356 1.356 0 014.975 0h2.714a1.357 1.357 0 011.357 1.357v.452h3.166a.452.452 0 010 .9h-.9v7.689a2.262 2.262 0 01-2.266 2.271H3.618a2.262 2.262 0 01-2.261-2.261V2.714h-.9a.452.452 0 010-.9h3.161zm.9.453h3.623v-.453a.453.453 0 00-.453-.452H4.975a.452.452 0 00-.453.452zm-2.261.9v7.689a1.356 1.356 0 001.361 1.36h5.428a1.357 1.357 0 001.357-1.357V2.714zm4.075 1.359a.452.452 0 01.452.452v5.428a.452.452 0 01-.9 0V4.523a.452.452 0 01.448-.454",
  fillRule: "evenodd"
});

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.664 12.664",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgTrash;